import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeftIcon } from '@/assets/icons'
import { iconSizes } from '@/theme/tokens'
import { BackLinkButton } from './BackLink.styles'

export interface BackTarget {
	/** Where the arrow leads: the page's parent, never browser history. */
	path: string
	/** The parent's name, read out as "Back to {label}". */
	label: string
	/** Runs before the link is followed; `preventDefault()` keeps the reader here — an editor with unsaved changes asks first. */
	onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

/**
 * The back arrow that sits left of a page's title and leads to the page's
 * parent — the trip overview from a section page, the section list from a
 * detail page. A link to a fixed parent rather than `history.back()`, so it
 * lands in the same place on a deep link or a refresh.
 */
const BackLink: React.FC<BackTarget> = ({ path, label, onClick }) => (
	<BackLinkButton
		as={Link}
		to={path}
		variant="icon"
		aria-label={`Back to ${label}`}
		title={`Back to ${label}`}
		onClick={onClick}
	>
		<ArrowLeftIcon sx={{ fontSize: iconSizes.lg }} />
	</BackLinkButton>
)

export default BackLink
